import CartSettingsController from './cart-settings.controller';

const CartSettingsComponent = {
    selector: 'sbCartSettings',
    template: require('./cart-settings.html'),
    controller: CartSettingsController,
    bindings: {
        cartId: '<',
    },
};

export default CartSettingsComponent;



// WEBPACK FOOTER //
// ./src/app/components/cart-settings/index.js